import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$("header .nav ul li").eq(2).addClass("active"); 
var swiper = new Swiper(".mySwiper", {
    spaceBetween: 10,
    slidesPerView: 4,
    direction: 'vertical',

});
var swiper2 = new Swiper(".mySwiper2", {
    thumbs: {
        swiper: swiper,
    },
});
$(".section4 ul li").click(function() {
    $(this).toggleClass("active");
    $(this).find(".answer").slideToggle();
})